import formatMoney from "../../../formatMoney";

const monthMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export function buildDateQuery({ type, year, years, month, quarter, half }) {
  let query = {};

  if (type === "Monthly") {
    const monthNumber = monthMap[month];
    const startDate = new Date(year, monthNumber - 1, 1);
    const endDate = new Date(year, monthNumber, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Yearly") {
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Bi-Yearly") {
    const halves = {
      "1st Half": 1,
      "2nd Half": 2,
    };

    const halvesNumber = halves[half];
    const startMonth = (halvesNumber - 1) * 6;
    const endMonth = startMonth + 5;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Quarterly") {
    const quarters = {
      "1st Quarter": 1,
      "2nd Quarter": 2,
      "3rd Quarter": 3,
      "4th Quarter": 4,
    };
    const quarterNumber = quarters[quarter];

    if (!quarterNumber) {
      throw new Error(`Invaldi value: ${quarter}`);
    }
    const startMonth = (quarterNumber - 1) * 3;
    const endMonth = startMonth + 2;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth + 1, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  }

  return query;
}

export function getTaxableDate({ type, year, month, quarter, half }) {
  if (type === "Monthly") {
    const monthNumber = monthMap[month];
    return new Date(year, monthNumber, 0, 23, 59, 59, 999);
  }
  if (type === "Yearly") {
    return new Date(year, 11, 31, 23, 59, 59, 999);
  }
  if (type === "Bi-Yearly") {
    const halves = {
      "1st Half": 1,
      "2nd Half": 2,
    };
    const halvesNumber = halves[half];
    const endMonth = halvesNumber * 6 - 1;
    return new Date(year, endMonth + 1, 0, 23, 59, 59, 999);
  }
  if (type === "Quarterly") {
    const quarters = {
      "1st Quarter": 1,
      "2nd Quarter": 2,
      "3rd Quarter": 3,
      "4th Quarter": 4,
    };
    const quarterNumber = quarters[quarter];
    if (!quarterNumber) {
      throw new Error(`Invalid value: ${quarter}`);
    }
    const endMonth = (quarterNumber - 1) * 3 + 2;
    return new Date(year, endMonth + 1, 0, 23, 59, 59, 999);
  }
  return new Date(year, 11, 31, 23, 59, 59, 999);
}

export function parseMoney(value) {
  if (!value) return 0;
  return parseFloat(value.replace(/,/g, ""));
}

export function getTopSales(data) {
  // const sales = data.filter((item) => item.type === "sale");
  // if (sales.length === 0) return 0;
  if (data.length === 0) return 0;
  const top = Math.max(...data.map((item) => parseMoney(item.gross)));
  return formatMoney(top);
}

export function getTotalGross(data) {
  const totalPurchase = data
    // .filter((item) => item.type === "purchase")
    .reduce((sum, item) => sum + parseMoney(item.gross), 0);

  return totalPurchase;
}

export function getNetProfit(data) {
  const totalSales = data
    .filter((item) => item.type === "sale")
    .reduce((sum, item) => sum + parseMoney(item.gross), 0);

  const totalPurchases = getTotalGross(data);

  return totalSales - totalPurchases;
}

export function getAllYears() {
  const currentYear = new Date().getFullYear();
  const startYear = 2000;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  return years;
}

function formatDate(isoString) {
  const date = new Date(isoString);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function parseNumberString(str) {
  if (typeof str !== "string") return NaN;
  const num = Number(str.replace(/,/g, ""));
  return isNaN(num) ? NaN : num;
}

export function filterWithVatable(array) {
  if (!Array.isArray(array) || array.length === 0) {
    return [];
  }

  const filteredArray = array.filter((arr) => {
    return arr.supplier.isVatable === true;
  });

  return filteredArray;
}

export function convertArrayForSheet1(array) {
  if (!Array.isArray(array) || array.length === 0) {
    return [
      {
        Date: "",
        "TIN#": "",
        "Company Name": "",
        Address: "",
        Gross: "",
        "Vatable Sales": "",
        "Vat Amount": "",
      },
    ];
  }

  const convertedArray = array.map((object) => {
    return {
      Date: formatDate(object?.date),
      "TIN#": object?.supplier.tinNo !== "" ? object?.supplier.tinNo : "N/A",
      "Company Name": object?.supplier?.name,
      Address: object?.supplier?.city,
      Gross: parseNumberString(object?.gross) || object?.gross,
      "Vatable Sales": parseNumberString(object?.net) || object?.net,
      "Vat Amount": parseNumberString(object?.vat) || object?.net,
    };
  });

  return convertedArray;
}

const biYearlyMonths = {
  "1st Half": ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE"],
  "2nd Half": [
    "JULY",
    "AUGUST",
    "SEPTEMBER",
    "OCTOBER",
    "NOVEMBER",
    "DECEMBER",
  ],
};

const biYearlyHalves = {
  "1st Half": "1st HALF",
  "2nd Half": "2nd HALF",
};

const quarterlyMonths = {
  "1st Quarter": ["JANUARY", "FEBRUARY", "MARCH"],
  "2nd Quarter": ["APRIL", "MAY", "JUNE"],
  "3rd Quarter": ["JULY", "AUGUST", "SEPTEMBER"],
  "4th Quarter": ["OCTOBER", "NOVEMBER", "DECEMBER"],
};

const quarters = {
  "1st Quarter": "1st QUARTER",
  "2nd Quarter": "2nd QUARTER",
  "3rd Quarter": "3rd QUARTER",
  "4th Quarter": "4th QUARTER",
};

function getClientDisplayName(client) {
  if (!client) return "";
  return (
    client.companyName ||
    client.ownerName ||
    client.name ||
    ""
  ).trim();
}

function getReportTypeLabel(collectionName) {
  if (collectionName === "sales") return "Sales";
  if (collectionName === "purchases") return "Purchases";
  return "";
}

export function buidlTitles({
  type,
  year,
  years,
  month,
  quarter,
  half,
  collectionName,
  client,
}) {
  let titles = {};
  const clientName = getClientDisplayName(client);
  const reportType = getReportTypeLabel(collectionName);
  const reportPrefix =
    reportType && clientName
      ? `${reportType} - ${clientName} - `
      : reportType
        ? `${reportType} - `
        : clientName
          ? `${clientName} - `
          : "";

  switch (type) {
    case "Monthly":
      titles = {
        title: `FOR THE MONTH OF ${month} ${year}`,
        totalTitles: `TOTAL - ${month} YEAR ${year}`,
        filename: `${reportPrefix}${month} ${year}`.trim() || `SLSP - ${month} ${year}`,
      };
      break;
    case "Yearly":
      titles = {
        title: `FOR THE YEAR OF ${year} `,
        totalTitles: `TOTAL - YEAR ${year}`,
        filename: `${reportPrefix}${year}`.trim() || `SLSP - ${year}`,
      };
      break;
    case "Bi-Yearly": {
      const months = biYearlyMonths[half];
      const halves = biYearlyHalves[half];

      titles = {
        title: `FOR THE MONTHS OF ${months.join(", ")} ${year}`,
        totalTitles: `TOTAL - ${halves} YEAR ${year}`,
        filename:
          `${reportPrefix}${halves} ${year}`.trim() || `SLSP - ${halves} ${year}`,
      };
      break;
    }
    default: {
      const quarterMonths = quarterlyMonths[quarter];
      const quarterly = quarters[quarter];
      titles = {
        title: `FOR THE MONTHS OF ${quarterMonths.join(", ")} ${year}`,
        totalTitles: `TOTAL - ${quarterly} YEAR ${year}`,
        filename:
          `${reportPrefix}${quarterly} ${year}`.trim() ||
          `SLSP - ${quarterly} ${year}`,
      };
    }
  }

  return titles;
}

export function exportableSLSP({ array, sumFields = [] }) {
  if (!Array.isArray(array)) {
    return [
      {
        date: "",
        tinNo: "",
        regName: "",
        supplierName: "",
        address: "",
        gross: "",
      },
    ];
  }

  const grouped = array.reduce((acc, item) => {
    const supplierId = item?.supplier?.id;
    if (!supplierId) return acc;

    if (!acc[supplierId]) {
      acc[supplierId] = {
        supplier: item.supplier,
      };

      sumFields.forEach((field) => {
        acc[supplierId][field] = 0;
      });
    }

    sumFields.forEach((field) => {
      acc[supplierId][field] += Number(item[field] || 0);
    });

    return acc;
  }, {});
}
